export const ADMIN_ONLY_ROLES = ['admin']
export const STAFF_ROLES = ['teacher', 'admin']
export const AUTHENTICATED_ROLES = ['student', 'teacher', 'admin']
export const STUDENT_ONLY_ROLES = ['student']
